import { PSApplication } from '../components/app/PSApplication'
import { Message } from '../models/Message'
import { RecordFactory } from '../models/RecordFactory'
import { SQLiteFactory } from '../models/SQLiteFactory'
import { registerDevice } from '../modules/apiclient'
import { NotificationType } from '../types/NotificationType'
import { WSS_BASE } from '../utils/constants'

let websocketRetryCount = 0

const handleIncomingEvent = async (
    event: MessageEvent<any>,
    postNotificationRef: { current: (notificationType: NotificationType, data?: any) => void },
    getNotificationDataRef: { current: (notificationType: NotificationType) => any }
) => {
    console.log('Websocket message', event.data)
    const remoteMessage = JSON.parse(event.data)
    const { data, badge, alert } = remoteMessage

    if (data && data.type === 'message' && data.id) {
        const inAppNotification = (result: Message) => {
            const message = result
            const threadId = message?.thread
            const pathParts = window.location.pathname.split('/').filter((part) => part !== '')
            const viewingInbox = pathParts?.length && pathParts[0] === 'messages'
            const threadIsOpen = viewingInbox && pathParts.length > 1 && pathParts[1] === threadId
            const notificationsGranted =
                window.Notification && window.Notification.permission === 'granted'

            if (!threadIsOpen && notificationsGranted && data.sender_id && alert) {
                RecordFactory.getInstance()
                    .loadUser(data.sender_id)
                    .then((value) => {
                        const title = value?.firstName
                            ? `New message from ${value.firstName}`
                            : 'New message'
                        new Notification(title, { body: alert, icon: '/logo192.png' })
                    })
            }

            if (message) {
                if (badge) {
                    SQLiteFactory.getInstance().setBadgeCount(badge)
                }
                postNotificationRef.current('MessagesDataSourceChanged', [message])
                postNotificationRef.current('MessagesTabDataSourceChanged', null)

                if (message.type !== 'person' && message.type !== 'team') {
                    postNotificationRef.current('DashboardDataSourceChanged', null)
                }
                if (message.type === 'booking') {
                    postNotificationRef.current('ScheduleDataSourceChanged', null)
                }
            }
        }

        const result = await RecordFactory.getInstance().fetchMessage(data.id)
        if (!result.ok) {
            return
        }
        inAppNotification(result.value)
    }
    else if (data && data.type === 'intent') {
        // The payment intent webhook is fired just before the charge is fully captured, delay a bit to ensure the charge is captured on stripes side
        setTimeout(() => {
            const previousEventData = getNotificationDataRef.current('IntentStatusChanged')
            if (previousEventData.pendingIntent === data.intent && data.status === 'succeeded') {
                postNotificationRef.current('IntentStatusChanged', {
                    completeIntent: data.intent,
                    status: 'succeeded',
                })
            }
            else if (
                previousEventData.pendingIntent === data.intent &&
                data.status === 'payment_failed'
            ) {
                postNotificationRef.current('IntentStatusChanged', {
                    failedIntent: data.intent,
                    status: 'failed',
                })
            }
        }, 250)
    }
}

export const connectWebSocket = ({
    postNotificationRef,
    getNotificationDataRef,
}: {
    postNotificationRef: { current: (notificationType: NotificationType, data?: any) => void }
    getNotificationDataRef: { current: (notificationType: NotificationType) => any }
}) => {
    const browserId = localStorage.getItem('id')
    const websocket = new WebSocket(`${WSS_BASE}/websocket/desktop/${browserId}`)

    websocket.onopen = (e) => {
        websocketRetryCount = 0
        const userId = PSApplication.me().id
        if (!userId) return
        console.debug('Websocket opened')
        const browserAddress = `DESKTOP:WSS:${userId}:${browserId}`
        registerDevice(browserAddress)
    }

    websocket.onmessage = (event: MessageEvent<any>) => {
        handleIncomingEvent(event, postNotificationRef, getNotificationDataRef)
    }

    websocket.onclose = (e) => {
        console.debug('Websocket close', e)
        if (e && e.reason && e.reason.indexOf('authentication required') === 0) {
            // store.dispatch(userLogout())
        }
        else if (websocketRetryCount < 15) {
            websocketRetryCount += 1
            // Retry with a delay that increases exponentially, up to 163 seconds
            setTimeout(
                () => connectWebSocket({ postNotificationRef, getNotificationDataRef }),
                2 ** websocketRetryCount * 10
            )
        }
        else {
            // fatal error logout
            //store.dispatch(userLogout())
        }
    }

    websocket.onerror = (e) => {
        console.debug('Websocket error', e)
    }
}
